import styled from "styled-components";

export const PlayerContainer = styled.div(({ theme }) => ({
    width: "100%",
    zIndex: 30,
    marginTop: theme.spacing.xxLarge,
    // LottieAnimation renders a button wrapper that would otherwise shrink-wrap the animation
    "& > button": {
        display: "block",
        width: "100%",
    },
}));
